module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-panel', {
    attrs: {
      "left": "",
      "reveal": _vm.isiOS,
      "cover": _vm.isMaterial
    }
  }, [_c('f7-navbar', {
    attrs: {
      "title": "Menu"
    }
  }), _vm._v(" "), _c('f7-page', [_c('f7-block-title', [_vm._v("Links")]), _vm._v(" "), _c('f7-list', [_c('f7-list-item', {
    attrs: {
      "link": "/home",
      "title": "Home",
      "link-view": "#main-view",
      "link-reload": "",
      "link-close-panel": ""
    }
  }), _vm._v(" "), _c('f7-list-item', {
    attrs: {
      "link": "/about",
      "title": "About",
      "link-view": "#main-view",
      "link-reload": "",
      "link-close-panel": ""
    }
  }), _vm._v(" "), _c('f7-list-item', {
    attrs: {
      "link": "/services/",
      "title": "Services",
      "link-view": "#main-view",
      "link-reload": "",
      "link-close-panel": ""
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-77391acc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/LeftPanel.vue
// module id = 327
// module chunks = 2